import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';
import installSlots from './config/slots';

function applyConfig(config: ConfigType) {
  installSettings(config);
  installSlots(config);

  return config;
}

export default applyConfig;
